import ProjectLanguageSelector from '../../core/ProjectLanguageSelector';
import TitledTextField from '../../core/TitledTextField';
import ProjectUsers from '../../core/ProjectUsers';
import TitledPanel from '../../core/TitledPanel';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import React from 'react';
import PrimaryButton from '../PrimaryButton';
import { lightSanitiseText } from '../../core/utils/utils';
import { globalStyles as styles } from '../style/gstheme';
import DialogMultiActions from '../DialogMultiActions';

class AssignUserDialog extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            user: "All",
            text: "",
            lang: this.props.defaultLang
        };
    }

    handleUserChange = (user) => this.setState({ user });

    assignUser = (notify = false) => () => this.props.onAssignUser(this.state.user, this.state.text, this.state.lang, notify);

    selectLanguage = (lang) => this.setState({ lang });

    handleChange = event => {
        const t = event.target;
        const cleanText = lightSanitiseText(t.value.trimLeft());
        this.setState({ [t.name]: cleanText });
    };

    render() {

        const { classes, onCancel, projectUsers, allowInstructions, existingNotes, exclude } = this.props;
        const { text, lang, user } = this.state;

        const existing = existingNotes && existingNotes[lang] ?
            Array.isArray(existingNotes[lang]) ?
                existingNotes[lang].includes(text)
                :
                existingNotes[lang] === text
            :
            false;
        const isExcludedUser = user === exclude;

        return (
            <React.Fragment>
                <Dialog
                    data-test="assign-user-dialog"
                    maxWidth="md"
                    fullWidth
                    classes={{
                        paperWidthMd: classes.mediumDialogOverflow
                    }}
                    open={true}
                    onClose={onCancel}
                    aria-labelledby="assign-user-dialog-title">
                    <DialogTitle data-test="assign-user-title" disableTypography className={classes.mainHeading} id="assign-user-dialog-title">Assign User</DialogTitle>
                    <DialogContent data-test="assign-user-dialog" style={{
                        maxHeight: '500px',
                        overflowY: 'scroll'
                    }}>
                        <div style={{ marginBottom: allowInstructions ? 0 : 24 }}>
                            <TitledPanel dataTest="assignee" height="full" title="Assign To">
                                <ProjectUsers
                                    projectUsers={projectUsers}
                                    allLabel="Unassigned"
                                    disable={exclude}
                                    includeLabel={false}
                                    onUserChange={this.handleUserChange} />
                            </TitledPanel>
                        </div>
                        {allowInstructions &&
                            <div>
                                <TitledPanel margin={true} title="Language">
                                    <ProjectLanguageSelector selectedLang={lang} includeLabel={false} onSelect={this.selectLanguage} />
                                </TitledPanel>
                                <TitledTextField
                                    dataTest="language-text"
                                    name="text"
                                    title="Instructions"
                                    margin={true}
                                    lang={lang}
                                    placeholder="Enter a note relating to your assignment"
                                    required={false}
                                    text={text}
                                    helperText={
                                        existing ?
                                            "This note already exists."
                                            :
                                            ""}
                                    multiline={true}
                                    rows={3}
                                    maxLength={500}
                                    onEnter={text.length > 0 && lang !== "" ? this.addItem : null}
                                    onChange={this.handleChange} />
                            </div>
                        }
                    </DialogContent>
                    <DialogMultiActions onCancel={onCancel}>
                        <PrimaryButton disabled={existing || isExcludedUser} dataTest="assign-resource" onClick={this.assignUser(false)}>Assign</PrimaryButton>
                        {user !== "All" &&
                            <PrimaryButton disabled={existing || isExcludedUser} dataTest="assign-resource-notify" onClick={this.assignUser(true)}>Assign and Notify</PrimaryButton>
                        }
                    </DialogMultiActions>
                </Dialog>
            </React.Fragment>
        );
    }
}

AssignUserDialog.defaultProps = {
    allowInstructions: true
};

AssignUserDialog.propTypes = {
    classes: PropTypes.object,
    onCancel: PropTypes.func.isRequired,
    allowInstructions: PropTypes.bool,
    existingNotes: PropTypes.object,
    exclude: PropTypes.string,
    onAssignUser: PropTypes.func.isRequired,
    defaultLang: PropTypes.string.isRequired,
    projectUsers: PropTypes.array
};

export default withStyles(styles)(AssignUserDialog);